// 获取操作系统
export function getOperateSystem () {
  let agent = navigator.userAgent.toLocaleLowerCase()
  let isMac = /macintosh|mac os x/i.test(agent);
  if (/(iPhone)/i.test(navigator.userAgent)) {
    return 'IOS'
  }
  if (/(iPad)/i.test(navigator.userAgent)) {
    return 'iPad'
  }
  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
    return 'win32'
  }
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    return 'win64'
  }
  if (isMac) {
    return 'mac'
  }
  if (/(Android)/i.test(agent)) {
    return 'Android'
  }
  return 'other'
}